import { render, staticRenderFns } from "./database-tool-header.vue?vue&type=template&id=61141d50&scoped=true&"
import script from "./database-tool-header.vue?vue&type=script&lang=ts&"
export * from "./database-tool-header.vue?vue&type=script&lang=ts&"
import style0 from "./database-tool-header.vue?vue&type=style&index=0&id=61141d50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61141d50",
  null
  
)

export default component.exports